import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { cancelInvoice } from 'src/shared/services/invoiceService';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useGlobals } from 'src/shared/contexts/appContext';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';

type CancelInvoiceDialogProps = {
  invoiceId: number;
  showDialog: boolean;
  callback: () => void;
};

export const CancelInvoiceDialog = (props: CancelInvoiceDialogProps) => {
  const { invoiceId, showDialog, callback } = props;
  const { setDateStamp } = useGlobals();
  const isMounted = useIsMounted();

  const { t } = useTranslation(['common', 'invoice']);

  const handleClose = () => {
    setDateStamp(new Date());
    callback();
  };

  const handleCancel = async () => {
    try {
      await cancelInvoice(invoiceId);
      if (isMounted()) {
        toast.success(<>{t('invoice:CancelInvoiceSuccess')}</>);
        setDateStamp(new Date());
        callback();
      }
    } catch (e) {
      if (isMounted()) {
        toast.error(<>{t('invoice:CancelInvoiceError')}</>);
        callback();
      }
    }
  };

  return (
    <div>
      <Dialog open={showDialog} onClose={handleClose} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
        <DialogTitle id='alert-dialog-title'>{t('invoice:CancelInvoicePromt')}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose}>{t('common:button.cancel')}</Button>
          <Button onClick={handleCancel} autoFocus>
            {t('invoice:Cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
